<template>
  <div class="tw-flex tw-flex-row">
    <div
      v-for="(dot, idx) in 3"
      :key="idx"
      class="tw-min-h-2 tw-min-w-2 tw-mx-1 tw-rounded-full tw-duration-75"
      :class="{
        'tw-bg-sf-snow-darker': activeDot !== idx,
        'tw-bg-black': activeDot === idx,
      }"
    />
  </div>
</template>

<script setup lang="ts">
import { defineOptions, ref, onMounted, onBeforeUnmount } from 'vue'

defineOptions({
  name: 'SfLoadingDots',
})

const activeDot = ref(0)
let dotInterval: number | undefined

function startDotAnimation() {
  dotInterval = window.setInterval(() => {
    activeDot.value = (activeDot.value + 1) % 3
  }, 500)
}

function stopDotAnimation() {
  if (dotInterval) {
    clearInterval(dotInterval)
    dotInterval = undefined
  }
}

onMounted(() => {
  startDotAnimation()
})

onBeforeUnmount(() => {
  stopDotAnimation()
})
</script>
